// @flow
// @flow-runtime warn
import { createContext } from 'react';

import { type OrderType, type ReceiverItem, type OrderItem } from './OrderTypes';


const defaultOrder = {
  id: null,
  number: null,
  date: '',
  shipping_method_id: null,
  payment_method_id: null,
  shipping_cost: null,
  payment_type: null,
  total: '',
  amount_discount: '',
  discount_code: null,
  name: null,
  email: null,
  phone: null,
  postal_code: null,
  state_code: null,
  state_name: null,
  city: null,
  street: null,
  comment: null,
  is_callback: null,
  shipping_status: null,
  payment_status: null,
  payment_method_type: null,
  shipping_method_type: null,
  delivery_point: {},
  receivers: [],
  order_items: [],
  issue_transactions: [],
  current_issue_statuses: [],
};

type ContentType = {
  order: OrderType,
  receivers: Array<ReceiverItem>,
  orderItemsNotIssued: Array<OrderItem>,
}

const defaultContent: ContentType = {
  order: defaultOrder,
  receivers: [],
  orderItemsNotIssued: [],
};

type LoadingType = {
  order: boolean,
  issue: boolean,
  receivers: boolean,
}

const defaultLoading: LoadingType = {
  order: true,
  issue: true,
  receivers: true,
};

type IssueType = {
  order_item_id: number,
  status: 'issued' | 'not_issued',
}

type RequestsType = {
  order: () => Promise<boolean> | boolean,
  issue: (items: Array<IssueType>) => Promise<boolean> | boolean,
  receivers: () => Promise<boolean> | boolean,
}

const defaultRequests = {
  order: () => false,
  issue: () => false,
  receivers: () => false,
};

type UpdateType = {
  order: (order: OrderType | (order: OrderType) => OrderType) => void,
}

const defaultUpdate = {
  order: () => {},
};

type OrderContextType = {
  content: ContentType,
  loading: LoadingType,
  request: RequestsType,
  update: UpdateType,
}

const defaultContext: OrderContextType = {
  content: defaultContent,
  loading: defaultLoading,
  request: defaultRequests,
  update: defaultUpdate,
};

export default createContext<OrderContextType>(defaultContext);
